import { render, staticRenderFns } from "./BusinessCardBindingWechatOperationInstructions.vue?vue&type=template&id=0da30440&scoped=true&"
import script from "./BusinessCardBindingWechatOperationInstructions.vue?vue&type=script&lang=js&"
export * from "./BusinessCardBindingWechatOperationInstructions.vue?vue&type=script&lang=js&"
import style0 from "./BusinessCardBindingWechatOperationInstructions.vue?vue&type=style&index=0&id=0da30440&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0da30440",
  null
  
)

export default component.exports